// extracted by mini-css-extract-plugin
export default {"eyeBrow":"_f38dc5ad","text":"_e7695001","textAlignCenter":"_4986c907","contentColorWhite":"_92e9f38f","header":"_f537adc3","dek":"_e1662876","cta":"_d3ff2d8a","outline":"_dae6bbfc"};